var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"package-iframe-c"},[(_vm.iframeInformations?.status)?[_c('iframe',{staticClass:"iframe-sc",attrs:{"src":_vm.IframeUrl,"title":"Schimetterling Login","width":"100%","height":"100%"},on:{"load":_vm.hidePreloader}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }